
import { defineComponent, onMounted, getCurrentInstance } from "vue";

export default defineComponent({
  props: {
    confirmHandler: {
      type: Function,
      default: undefined,
    },
    size: {
      type: String,
      default: "",
    },
  },
  setup(props, target) {
    onMounted(() => {
      const modal = getCurrentInstance()?.refs.modal as HTMLHtmlElement;
      modal.addEventListener("shown.bs.modal", () => {
        target.emit("open");
      });
    });

    return {
      props,
    };
  },
  methods: {
    handleSubmit(e: Event) {
      e.preventDefault();
      this.confirmHandler && this.confirmHandler();
      const closeButton = this.$refs.closeButton as HTMLButtonElement;
      closeButton.click();
    },
  },
});
